const { AppError } = require('@icabbi/errors');
const _ = require('lodash');

module.exports = {
  errorMapper: (err) => {
    if (_.has(err, 'response.data.errors')) {
      return new AppError({
        ...err.response.data.errors[0],
        httpStatusCode: _.get(err, 'response.status', 500),
      });
    }
    return new AppError({
      httpStatusCode: _.get(err, 'response.status', 500),
      message: `${err.message} - ${_.get(err, 'config.method', 'get')} ${_.get(err, 'config.url', '')}`,
      innerError: err,
      details: _.get(err, 'response.data', ''),
      code: 'ERR_UNKNOWN',
    });
  },
};
